<template>
  <div class="app-content auth">
    <Navbar />
    <div class>
      <div class="text-white px-5 md:px-0 mt-10">
        <div class="text-center w-full md:w-1/2 mx-auto">
          <h1
            class="text-2xl md:text-5xl mb-5 md:mb-0 leading-none font-bold space-x-1"
          >
            <span class="text-custom">Sign Up</span>
          </h1>
        </div>

        <div class="md:w-4/5 lg:w-3/5 mx-auto">
          <div class="mt-3 text-left md:text-right">
            <div
              v-if="$route.query.type == 'referral'"
              class="w-full md:flex justify-end items-center font-medium p-2 md:mb-3"
            >
              You have been reffered, Please complete the Signup process to
              start using the Spyows platform.
            </div>
            <div class="text-xl mx-auto text max-w-3xl py-4 md:px-4">
              <div
                class="w-full md:flex justify-end items-center font-medium p-2 md:mb-3"
              >
                <span class="text-white mr-3 w-auto">Display Name:</span>
                <input
                  type="text"
                  v-model="name"
                  class="focus:outline-none w-full md:w-3/4 text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-full px-5"
                  placeholder="Enter display name here"
                  :required="true"
                />
              </div>
              <div
                class="w-full md:flex justify-end items-center font-medium p-2 md:mb-5"
              >
                <span class="text-white mr-3">Email:</span>
                <input
                  type="text"
                  v-model="email"
                  class="focus:outline-none w-full md:w-3/4 text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-full px-5"
                  placeholder="Enter email here"
                  :required="true"
                />
              </div>
              <div
                class="w-full md:flex justify-end items-center font-medium p-2 md:mb-5"
              >
                <span class="text-white mr-3">Password:</span>
                <input
                  type="password"
                  v-model="password"
                  class="focus:outline-none w-full md:w-3/4 text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-full px-5"
                  placeholder="Enter password here"
                  :required="true"
                />
              </div>
              <div
                class="w-full md:flex justify-end items-center font-medium p-2 md:mb-3"
              >
                <span class="text-white mr-3 w-auto">Confirm Password:</span>
                <input
                  type="password"
                  v-model="confirmPassword"
                  class="focus:outline-none w-full md:w-3/4 text-gray-900 bg-white py-2 md:py-3 bg-opacity-75 border rounded-full px-5"
                  placeholder="Enter confirm password here"
                  :required="true"
                />
              </div>
              <div
                class="w-full md:flex justify-end items-center font-medium p-2 md:mb-3"
              >
                <span class="text-white mr-3 w-auto">Phone number:</span>
                <VuePhoneNumberInput
                  v-model="phoneNumber"
                  size="lg"
                  :dark="true"
                  color="black"
                  valid-color="#008000"
                  error-color="#ff0000"
                  dark-color="#c2c3c4"
                  :show-code-on-list="true"
                  :border-radius="30"
                  default-country-code="US"
                  mode="international"
                  :enabledCountryCode="true"
                  :validCharactersOnly="true"
                  @update="onUpdate"
                  class="phone-ctr focus:outline-none w-full md:w-3/4 text-gray-900 py-2 md:py-3 bg-opacity-75 px-5"
                />
              </div>
              <div class="w-full md:w-3/4 mx-auto text-left md:text-center">
                <label class="inline-flex items-center my-3 md:ml-0">
                  <input
                    type="checkbox"
                    class="form-checkbox h-4 w-4 text-primary bg-custom"
                    @change="isChecked = !isChecked"
                  />
                  <span
                    class="cursor-pointer ml-2 text-xs md:text-sm lg:text-md font-bold text-gray-200 leading-none"
                  >
                    Agree to our
                    <router-link class="text-custom" to="/privacy-policy"
                      >privacy policy</router-link
                    >and our
                    <router-link class="text-custom" to="/legal"
                      >disclaimer</router-link
                    >
                  </span>
                </label>
              </div>
              <div
                class="w-full md:flex justify-end items-center font-medium p-2"
              >
                <button
                  :disabled="!isChecked"
                  class="btn focus:outline-none w-full md:w-3/4 text-lg text-white shadow px-10"
                  :class="{ 'cursor-not-allowed opacity-50': !isChecked }"
                  @click="signUpWIthEmailAndPassword"
                >
                  Sign up
                </button>
              </div>
            </div>
          </div>
          <div class="md:w-4/5 mx-auto text-center">
            <div class="md:ml-20">
              <div class="mx-auto w-auto block -mb-5 pb-1">
                <span class="text-center text-xs text-gray-300"
                  >or sign up with</span
                >
              </div>
              <div class="md:flex items-center w-full mt-2">
                <div
                  class="w-full md:w-1/3 px-1 pt-4 mx-1 md:border-t md:border-gray-400"
                >
                  <button
                    class="appearance-none flex justify-center items-center leading-tight w-full bg-blue-800 hover:bg-blue-900 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                    type="button"
                    @click="signUpWithFacebook"
                  >
                    <i class="bx bxl-facebook mr-1"></i>
                    Facebook
                  </button>
                </div>
                <div class="w-full md:w-1/3 px-1 pt-4 mx-1">
                  <button
                    class="appearance-none flex justify-center items-center leading-tight w-full bg-red-700 hover:bg-red-800 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                    type="button"
                    @click="signUpWithGoogle"
                  >
                    <i class="bx bxl-google mr-1"></i>
                    Google
                  </button>
                </div>
                <div
                  class="w-full md:w-1/3 px-1 pt-4 mx-1 md:border-t md:border-gray-400"
                >
                  <button
                    class="appearance-none flex justify-center items-center leading-tight w-full bg-gray-500 hover:bg-gray-700 font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                    type="button"
                    @click="signUpWithApple"
                  >
                    <i class="bx bxl-apple mr-1"></i>
                    Apple ID
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-5 text-xl text-center">
            <p>
              Already have an account?
              <router-link class="text-custom" to="/login">Login</router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer>Welcome</Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/layout/Nav.vue";
import Footer from "@/components/layout/Footer.vue";
import firebase from "firebase";
import helper from "@/providers/helper";
import Auth from "@/providers/auth";
import VuePhoneNumberInput from "vue-phone-number-input";
import Vue from "vue";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  name: "Login",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Login",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Navbar,
    Footer,
    VuePhoneNumberInput
  },
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      isChecked: false,
      phoneNumber: "",
      phoneNumberResults: {},
      name: ""
    };
  },
  methods: {
    signUpWIthEmailAndPassword: function() {
      if (
        this.isChecked &&
        (this.name || "").length &&
        (this.email || "").length &&
        (this.password || "").length &&
        (this.confirmPassword || "").length
      ) {
        if (this.password == this.confirmPassword) {
          Auth.signUpWithEmailAndPassword(this.email, this.password, {
            displayName: this.name,
            phoneNumber: this.phoneNumberResults["formattedNumber"]
          })
            .then(user => {
              return this.routeBasedOnSubscriptionData(user.uid);
            })
            .catch(err => {
              console.error("err occured", err);
              this.$vToastify.error(err, "Failed to Signup");
            });
        } else {
          this.$vToastify.error("Password & Confirm password should be same");
        }
      } else {
        this.$vToastify.error("Enter all the required fields");
      }
    },
    signUpWithGoogle: function() {
      Auth.signUpWithGoogle()
        .then(user => {
          return this.routeBasedOnSubscriptionData(user.uid);
        })
        .catch(err => {
          console.error("err occured", err);
          if (err.code == "UserAlreadyExists") {
            Auth.signOut(this.$router)
              .then(() => {
                this.$vToastify.error(err.message, "Failed to Signup");
              })
              .catch(err => {
                console.error("err occured while signout", err);
                this.$vToastify.error(
                  (err || {}).message || "Failed to SignUp the user",
                  "Failed to Signup"
                );
              });
          } else {
            this.$vToastify.error(err.message, "Failed to Signup");
          }
        });
    },
    signUpWithFacebook() {
      Auth.signUpWithFacebook()
        .then(user => {
          return this.routeBasedOnSubscriptionData(user.uid);
        })
        .catch(err => {
          console.log("err occured", err);
          if (err.code == "UserAlreadyExists") {
            Auth.signOut(this.$router)
              .then(() => {
                this.$vToastify.error(err.message, "Failed to Signup");
              })
              .catch(err => {
                console.error("err occured while signout", err);
                this.$vToastify.error(
                  (err || {}).message || "Failed to SignUp the user",
                  "Failed to Signup"
                );
              });
          } else {
            this.$vToastify.error(err.message, "Failed to Signup");
          }
        });
    },
    signUpWithApple() {
      Auth.signUpWithApple()
        .then(user => {
          return this.routeBasedOnSubscriptionData(user.uid);
        })
        .catch(err => {
          console.log("err occured", err);
          if (err.code == "UserAlreadyExists") {
            Auth.signOut(this.$router)
              .then(() => {
                this.$vToastify.error(err.message, "Failed to Signup");
              })
              .catch(err => {
                console.error("err occured while signout", err);
                this.$vToastify.error(
                  (err || {}).message || "Failed to SignUp the user",
                  "Failed to Signup"
                );
              });
          } else {
            this.$vToastify.error(err.message, "Failed to Signup");
          }
        });
    },
    onUpdate(payload) {
      this.phoneNumberResults = payload;
    },
    routeBasedOnSubscriptionData(uid) {
      return new Promise((resolve, reject) => {
        Auth.getSubscriptionDetails(uid)
          .then(subscriptionData => {
            console.log("subscriptionData", subscriptionData);
            if (!subscriptionData) {
              this.$router.push("/user/welcome");
            } else if (
              subscriptionData &&
              subscriptionData.status != "active"
            ) {
              this.$router.push("/user/payment");
            } else {
              this.$router.push("/user/subscriptions");
            }
            this.$vToastify.success(
              "User has been created successfully, please login to continue",
              "User creation success"
            );
            resolve();
          })
          .catch(err => {
            console.log("err occured", err)
            reject(err);
          });
      });
    }
  }
};
Vue.component("vue-phone-number-input", VuePhoneNumberInput);
</script>
<style lang="postcss" scoped>
.phone-ctr {
  padding: 0 !important;
}
</style>
